import { FlagProps } from "@/components/Flag/interaces/FlagProps.ts";
import { useGetOrganization } from "@/helpers/useGetOrganization.ts";
import "./Flag.scss";

const Flag = ({
  code = "NL",
  size = "l",
  gradient = "",
  hasBorder = true,
  hasDropShadow = false,
  hasBorderRadius = true,
  className,
}: FlagProps) => {
  const { organizationName } = useGetOrganization();

  if (organizationName === "Demo staging organization") {
    return (
      <div
        className={`flag ${gradient} size-${size} ${hasBorder ? "border" : ""} ${
          hasDropShadow ? "drop-shadow" : ""
        } ${hasBorderRadius ? "border-radius" : ""} ${
          className ? className.replace(/\s\s+/g, " ").trim() : ""
        }`}
      >
        <img src={`https://swen.booking-staging.hiswen.com/flags/${size}/${code}.svg`} alt={`${code} flag`} />
      </div>
    );
  }

  return (
    <div
      className={`flag ${gradient} size-${size} ${hasBorder ? "border" : ""} ${
        hasDropShadow ? "drop-shadow" : ""
      } ${hasBorderRadius ? "border-radius" : ""} ${
        className ? className.replace(/\s\s+/g, " ").trim() : ""
      }`}
    >
      <img src={`https://swen.booking.hiswen.com/flags/${size}/${code}.svg`} alt={`${code} flag`} />
    </div>
  );
};

export default Flag;
